import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trophy, ArrowRight, Clock } from "lucide-react";
import api from "@/lib/api";

// This week's global themed mashup challenge — a banner that deep-links into Mashup Studio pre-filled.
export default function MashupChallenge({ compact = false }) {
  const [c, setC] = useState(null);
  const [now, setNow] = useState(Date.now());
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/mashup/challenge").then((r) => setC(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(t);
  }, []);

  if (!c) return null;

  const go = () => {
    const qs = new URLSearchParams(c.params || {}).toString();
    navigate(`/app/mashup?${qs}`);
  };
  const countdown = () => {
    if (!c.resets_at) return null;
    const ms = new Date(c.resets_at).getTime() - now;
    if (ms <= 0) return "resetting…";
    const d = Math.floor(ms / 86400000), h = Math.floor((ms % 86400000) / 3600000), m = Math.floor((ms % 3600000) / 60000);
    return d > 0 ? `${d}d ${h}h` : h > 0 ? `${h}h ${m}m` : `${m}m`;
  };

  return (
    <div data-testid="mashup-challenge" className="mb-6 rounded-3xl p-5 border border-amber-400/40 bg-gradient-to-br from-amber-400/12 via-transparent to-fuchsia-500/10 animate-rise flex items-center gap-4">
      <div className="w-14 h-14 shrink-0 rounded-2xl grid place-items-center bg-gradient-to-br from-amber-400 to-fuchsia-500 shadow-lg">
        <Trophy className="w-7 h-7 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[11px] font-bold uppercase tracking-wide text-amber-500">🏆 Weekly Mashup Challenge</div>
        <div className="font-display text-lg font-extrabold truncate" data-testid="challenge-title">{c.title}</div>
        {!compact && <div className="text-sm text-[hsl(var(--muted-foreground))] truncate">{c.subtitle}</div>}
        <div className="flex flex-wrap items-center gap-1.5 mt-2">
          {(c.chips || []).map((chip, i) => (
            <span key={i} className="px-2 py-0.5 rounded-full text-[11px] font-semibold bg-[hsl(var(--secondary))]">{chip}</span>
          ))}
          <span className="text-[11px] text-[hsl(var(--muted-foreground))] ml-1">· {c.entries || 0} {c.entries === 1 ? "entry" : "entries"}</span>
          {countdown() && (
            <span className="px-2 py-0.5 rounded-full text-[11px] font-bold bg-amber-500/15 text-amber-600 dark:text-amber-300 flex items-center gap-1" data-testid="challenge-countdown">
              <Clock className="w-3 h-3" /> resets in {countdown()}
            </span>
          )}
        </div>
      </div>
      <button onClick={go} data-testid="challenge-build-btn" className="shrink-0 self-center rounded-full bg-gradient-to-r from-amber-500 to-fuchsia-500 text-white px-4 py-2 text-sm font-bold flex items-center gap-1">
        Build it <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}
